/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CurbsidePickupModel { 
    id: number;
    removed: boolean;
    createDate?: string;
    orderId: number;
    storeId: number;
    cbSeenDate?: string;
    cbUserId?: number;
    clientPhone: string;
    clientSendDate?: string;
    active: boolean;
    comment?: string;
}

